import { Button } from "@photo-booth/ui/button";
import { PageTransition } from "@/components/PageTransition";
import { useNavigate } from "react-router";
import { BackButton } from "@/components/BackButton";
import { analyticsClick } from "@/lib/analytics/props";
import { useSEO } from "@/lib/seo/useSEO";
import { usePrefetchFrames } from "@/hooks/api/usePrefetchFrames";
import { useEffectOnce } from "@/hooks/useEffectOnce";

export const PhotoBoothPage: React.FC = () => {
  const navigate = useNavigate();
  const { prefetchFrames } = usePrefetchFrames();

  useEffectOnce(() => {
    prefetchFrames();
  });

  const currentMonth = new Date().toLocaleString("default", { month: "long" });
  const currentYear = new Date().getFullYear();

  useSEO({
    title: "Select Frame Type - Photo Booth",
    description:
      "Choose your photo frame type - monthly frames or location-based frames. Start creating your photo booth experience with KeptScene.",
    keywords:
      "photo booth, select frame, monthly frames, location frames, KeptScene",
  });

  return (
    <PageTransition className="min-h-screen">
      <BackButton prevUrl="/" />
      <div className="px-8 my-6">
        <p className="text-5xl text-left text-vintage-red ps-12"> Select </p>
        <div className="w-full h-[1px] border-b-1 border-black" />
        <p className="text-5xl text-right text-vintage-red pe-12"> Type </p>
        <div className="flex flex-col items-center justify-center rounded-lg min-h-[50vh]">
          <Button
            className="relative z-10 bg-[url('/tape.png')] bg-transparent bg-cover bg-center w-full py-8 px-16 mt-16 text-vintage-black button-shadow rotate-3 active:rotate-0 focus:rotate-0 hover:rotate-0"
            onClick={() => navigate("/frame?type=monthly")}
            onMouseEnter={prefetchFrames}
            onFocus={prefetchFrames}
            {...analyticsClick({
              event: "monthly-frame-button",
              feature: "ui",
              location: window.location.pathname,
            })}
          >
            <div className="absolute -z-10 top-[-70%] left-[-5%]">
              <img
                src="/star.png"
                alt=""
                className="w-24 h-24"
                loading="lazy"
                aria-hidden="true"
              />
            </div>
            <p className="text-[60px] font-family-reenie"> Monthly </p>
          </Button>
          <div className="mt-1 w-full relative">
            <p className="text-[23px] text-right self-end text-vintage-red font-family-reenie">
              {" "}
              {`${currentMonth} ${currentYear}`}
            </p>
          </div>

          <Button
            className="relative z-10 bg-[url('/tape.png')] bg-transparent bg-cover bg-center w-full py-8 px-16 mt-8 text-vintage-black button-shadow -rotate-2 active:rotate-0 focus:rotate-0 hover:rotate-0"
            disabled
            {...analyticsClick({
              event: "location-frame-button",
              feature: "ui",
              location: window.location.pathname,
            })}
          >
            <p className="text-[60px] font-family-reenie"> Location </p>
          </Button>
          <div className="mt-1 w-full relative">
            <p className="text-[18px] text-right text-vintage-red font-family-reenie">
            {"Let's collaborate"}
            <br />
            {'contact us Line OA: @944efgii'}
            </p>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};
